import { SendNotificationMessage } from '../models';
import { REACT_APP_NOTIFICATION_URL } from 'config';
import { httpClient } from 'features/auth/utils/http';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

const sendNotification = async (message: SendNotificationMessage) => {
  await httpClient.post(`${REACT_APP_NOTIFICATION_URL}/notifications`, message);
};

export const useSendNotificationMutation = (
  options?: Omit<
    UseMutationOptions<Awaited<ReturnType<typeof sendNotification>>, QueryError, SendNotificationMessage, unknown>,
    'mutationFn'
  >
) =>
  useMutation((message) => sendNotification(message), {
    ...options,
    onError: (error: QueryError) => {
      const message = formatErrorMessage(error);
      toast.error(message);
      console.error(message);
    }
  });
